import React from "react"

import {IonCol, IonGrid, IonRow} from "@ionic/react";

import ItemType from "../../types/Key"

import ItemGroupInfo   from "../Keys/View/ItemGroupInfo"
import ItemGroupLinked   from "../Keys/View/ItemGroupLinked"
import ViewHeader      from "./ViewHeader"

import ButtonSync   from "../Keys/ButtonSync"
import ButtonBlock  from "../Keys/ButtonBlock"
import ButtonDelete from "../Keys/ButtonDelete"

export interface props {
    item: ItemType
}

const View: React.FC<props> = ({ item }) => {

    const viewButtons = () => {
        if (undefined !== item) {
            return (
                <>
                    {item.options?.isSynchronizable && <ButtonSync item={item} />}
                    <ButtonBlock item={item} />
                    {item.options?.isDeletable && <ButtonDelete item={item} />}
                </>
            )
        }
    }

    return (
        <div className="ion-text-center">
            <ViewHeader      item={item}    />
            <ItemGroupInfo   keyItem={item} />
            <ItemGroupLinked item={item} keyCollectionItemUrl={'/keys-in-safe/' + item.id} />

            <IonGrid className="ion-margin-top">
                <IonRow>
                    <IonCol className="ion-text-right">
                        {viewButtons()}
                    </IonCol>
                </IonRow>
            </IonGrid>
        </div>
    )
}

export default View